module.exports = __webpack_public_path__ + "img/account_icon.16e6e308.svg";